// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SupplierCodeApprvService = {};

SupplierCodeApprvService.getSupplierApprvList = function (userInput) {
  return lossClient({
    url: "/Supplier/approvalSuppliers?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default SupplierCodeApprvService;
